import logoImage from "../../images/b.png";
import DarklogoImage from "../navigation/d.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BiMoon, BiSun } from "react-icons/bi";
import { Link } from "react-router-dom";
import { useState } from "react";
import { RiEyeCloseLine } from "react-icons/ri";
import { MdLanguage, MdRemoveRedEye } from "react-icons/md";
import i18n from "../../i18next";
// import { useAushDispather } from "../../context/AuthProvider";

import { useTranslation } from "react-i18next";
// import { loginUser } from "../../services/loginService";
import { toast } from "react-toastify";
import i18next from "i18next";
// import { useAushDispather } from "../../context/AuthProvider";
const LoginForm = ({ history, setTheme, theme, changeLanguage }) => {
  const initialValues = {
    email: "",
    password: "",
  };
  // const AuthDis = useAushDispather();
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("include an @ email address ")
      .required("email is requried"),
    password: Yup.string()
      .required("No password provided.")
      .min(8, "Password is too short - should be 8 chars minimum")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number "
      ),
  });

  const onSubmit = (values) => {
    const userData = {
      name: values.name,
      phoneNumber: values.phone,
      email: values.email,
      password: values.password,
    };
    localStorage.setItem("user", JSON.stringify(userData));
    toast.success(`${userData.name} your Login is succses `, {
      autoClose: 1800,
      position: "top-left",
    });
    history.push("/");
    console.log(history);
  };

  // const onSubmit = async (values) => {
  //   const userData = {
  //     email: values.email,
  //     password: values.password,
  //   };
  //   try {
  //     const { data } = await loginUser(userData);
  //     toast.success(`${data.name} you are Login`);
  //     AuthDis("data");
  //     localStorage.setItem("user" , JSON.stringify(data))

  //   } catch (error) {
  //     if (error.response.data.message) {
  //       toast.error(`${error.response.data.message}`);
  //     }
  //   }

  const { t } = useTranslation();

  // };
  const Formik = useFormik({
    onSubmit,
    initialValues,
    validationSchema,
    validateOnMount: true,
  });
  const [show, setShow] = useState(false);

  return (
    <div className="dark:bg-Darkscreen text-Darktext dark:text-white h-[1000px]">
      <div>
        <nav>
          <div className="flex flex-row justify-between pt-[10px] ">
            <div className="mx-10 flex flex-row justify-between text-[22px] w-full dark:text-white text-thertext ">
              <div className=" pb-2 ">
                {theme === "lightTheme" ? (
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      setTheme("darkTheme");
                    }}
                    className="cursor-pointer "
                  >
                    <BiMoon className="inline" />
                  </span>
                ) : (
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      setTheme("lightTheme");
                    }}
                    className="cursor-pointer "
                  >
                    <BiSun className="inline" />
                  </span>
                )}
              </div>
              <div onClick={() => changeLanguage()}>
                {i18next.language === "fa" ? (
                  <span className="text-[15px] font-semibold">En</span>
                ) : (
                  <span className="text-[15px] font-semibold">فا</span>
                )}

                <MdLanguage className="inline" />
              </div>
            </div>
          </div>
          <div className="flex flex-col mt-5 self-center">
            <div className="self-center mb-2">
              <Link to={"/"}>
                <img
                  src={theme === "lightTheme" ? logoImage : DarklogoImage}
                  alt=""
                  onClick={(e) => {}}
                />
              </Link>{" "}
            </div>
          </div>
        </nav>
        <section className="flex flex-col  self-center mt-10  dark:bg-Darkscreen">
          <div className="self-center border  dark:border-[#717374] border-gray-500  p-5 rounded-md dark:bg-Darkscreen w-[310px] ">
            <form onSubmit={Formik.handleSubmit}>
              <div className="flex flex-col mb-5 ">
                <label htmlFor="1" className="mb-2 text-thertext">
                  Email
                </label>
                <input
                  type="text"
                  className="rounded-sm px-3 h-9 bg-transparent dark:bg-Darkscreen border  dark:border-[#717374] border-gray-400 
                outline-none ml-2"
                  name="email"
                  {...Formik.getFieldProps("email")}
                />
                {Formik.errors.email && Formik.touched.email && (
                  <div className="text-red-600 text-sm ">
                    {Formik.errors.email}
                  </div>
                )}
              </div>
              <div className="flex flex-col mb-5 ">
                <label
                  htmlFor="1"
                  className="mb-2 dark:text-[#b5b5b5] text-thertext "
                >
                  {t("pass")}
                </label>
                <div className="flex ">
                  <input
                    type={show ? "text" : "password"}
                    className={` text-Darktext dark:text-white ${
                      i18n.language === "fa" ? `rounded-r-sm ` : `rounded-l-sm`
                    } h-9  border  dark:border-[#717374] border-gray-400
                  outline-none   w-full ${
                    i18n.language === "en" ? `border-r-0` : `border-l-0`
                  }  px-2 bg-transparent`}
                    name="password"
                    {...Formik.getFieldProps("password")}
                  />
                  <div
                    className={`flex border dark:text-[#b5b5b5] text-thertext ${
                      i18n.language === "fa" ? `border-r-0` : `border-l-0`
                    }  ${
                      i18n.language === "en" ? `pr-3` : `pl-3`
                    }  border dark: dark:border-[#717374] border-gray-400  ${
                      i18n.language === "en" ? `rounded-r-sm` : `rounded-l-sm`
                    } `}
                  >
                    <button
                      className="self-center"
                      onClick={(e) => {
                        e.preventDefault();
                        setShow(!show);
                      }}
                    >
                      {!show ? <RiEyeCloseLine /> : <MdRemoveRedEye />}
                    </button>
                  </div>
                </div>

                {Formik.errors.password && Formik.touched.password && (
                  <div className="text-red-600 text-sm ">
                    {Formik.errors.password}
                  </div>
                )}
              </div>
              <div className="flex justify-center mb-5 pt-6 h-12">
                <button
                  className={
                    Formik.errors.email || Formik.errors.password
                      ? "dark:bg-[#2c323b] text-white self-center bg-gray-500 px-12 py-2 rounded-lg"
                      : "bg-btnMain self-center px-12 py-2 rounded-lg hover:px-13 hover:rounded-xl text-white hover:text-[19px] duration-300"
                  }
                  type="submit"
                  // onClick={(e)=>e.preventDefault()}
                  disabled={
                    Formik.errors.email || Formik.errors.password ? true : false
                  }
                >
                  {" "}
                  LOGIN
                </button>
              </div>
            </form>
            <div className="self-center my-8 text-sm">
              <div className="flex justify-center">
                <span className="mx-2">or</span>
                <Link to={"/singup"} className="text-btnMain">
                  Create a new account
                </Link>
              </div>
              <div className="flex justify-center">
                <Link className="text-btnMain">Forgot Password? </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default LoginForm;
